<template>
  <div class="swiper">
    <div class="mobile" v-if="isMobile == 1">
      <el-carousel trigger="click" height="310px">
        <el-carousel-item v-for="(item, index) in carousel" :key="index">
          <img style="width: 100%" :src="require('@/assets/' + item)" alt="" />
        </el-carousel-item>
      </el-carousel>
      <div class="btns">
        <div
          class="common-btn1 button-learn-more-yellow"
          @click="linkto('https://z.zcyit.cn/newreg/#/?regid=1134')"
        >
          体验申请
        </div>
        <div
          class="common-btn1 button-learn-more-white"
          @click="onlineConsultationShow = true"
        >
          在线咨询
        </div>
      </div>
    </div>
    <div class="pc" v-if="isMobile == 0">
      <el-carousel trigger="click" height="530px">
        <el-carousel-item v-for="(item, index) in carousel" :key="index">
          <img style="width: 100%" :src="require('@/assets/' + item)" alt="" />
        </el-carousel-item>
      </el-carousel>
      <div class="btns">
        <div
          class="common-btn1 button-learn-more-yellow"
           @click="linkto('https://z.zcyit.cn/newreg/#/?regid=1134')"
        >
          体验申请
        </div>
        <div
          class="common-btn1 button-learn-more-white"
          @click="onlineConsultationShow = true"
        >
          在线咨询
        </div>
      </div>
    </div>
    <!-- 点击在线咨询，出现一个包含名片图片的弹窗 -->
    <el-dialog
      :visible.sync="onlineConsultationShow"
      width="800px"
      center
      :close-on-click-modal="false"
      :show-close="true"
    >
      <img
        style="width: 100%"
        :src="require('@/assets/contact-card.jpg')"
        alt=""
      />
      <!-- 关闭按钮 -->
       <el-button
        slot="footer"
        class="dialog-footer"
        type="primary "
        plain
        @click="onlineConsultationShow = false"
      >
        关闭
      </el-button>
       
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "swiper",
  props: {
    msg: String,
  },
  data() {
    return {
      isMobile: false,
      onlineConsultationShow: false,
      carousel: [
        "banner.png",
        // "banner2.png",
        // "banner3.png",
        // "banner4.png",
        // "banner5.png",
      ],
    };
  },
  // created() {
  //   // this.$nextTick(()=>{
  //     // this.isMobile = localStorage.getItem("isMobile")
  //   // })
  // },
  mounted() {
    console.log(this.carousel[0]);
    // 根据不同路由跳转不同页面
    if (this._isMobile()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  methods: {
    // 单开一个页面
    linkto(url){
      window.open(url);
    },
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style scoped lang="less"></style>
<style scoped lang='less'>
.pc {
  position: relative;
  /deep/ .el-carousel__indicator--horizontal {
    padding: 60px 10px;

    .el-carousel__button {
      width: 30px;
      height: 5px;
      background: #ffffff;
      border-radius: 5px 5px 5px 5px;
    }
  }
  .btns {
    position: absolute;
    bottom: 50px;
    left: 260px;
    z-index: 10;
    .button-learn-more-yellow{
      margin-right: 20px;
    }
  }
}

.mobile {
  position: relative;
   .btns {
    position: absolute;
    bottom: 100px;
    left: 100px;
    z-index: 10;
    .button-learn-more-yellow{
      margin-right: 20px;
    }
  }
  /deep/ .el-carousel__indicator--horizontal {
    padding: 20px 10px;

    .el-carousel__button {
      width: 30px;
      height: 5px;
      background: #ffffff;
      border-radius: 5px 5px 5px 5px;
    }
  }
}

/deep/ .el-carousel__indicator--horizontal.is-active {
  .el-carousel__button {
    width: 60px;
  }
}
</style>

